module.exports = __webpack_public_path__ + "img/hr-roboport-base.ea465976.png";